import { showDialog } from "./lightbox";

export const initFormSuccess = () => {
  document.addEventListener(
    "wpcf7mailsent",
    (event) => {
      showDialog(event.detail.apiResponse.message)
    },
    false
  );
};
